module.exports = __webpack_public_path__ + "static/media/SelfAwarenessOfValues.c19172e8.mp3";